<template>
  <div class="page">
    <!-- 顶部导航栏：返回按钮 + 标题 -->
    <div class="nav-bar">
      <div class="nav-back" @click="goBack">
        <!-- 返回箭头 -->
        <svg viewBox="0 0 24 24">
          <path d="M15 18l-6-6 6-6" />
        </svg>
      </div>
      <div class="nav-title">号码管理</div>
    </div>

    <!-- 列表切换：左起 投注号码（默认） / 开奖号码 / 推荐号码，同时只展示一个列表 -->
    <div class="list-switch">
      <div
        class="list-switch-item"
        :class="{ active: activeList === 'bet' }"
        @click="switchList('bet')"
      >
        投注号码
      </div>
      <div
        class="list-switch-item"
        :class="{ active: activeList === 'draw' }"
        @click="switchList('draw')"
      >
        开奖号码
      </div>
      <div
        v-if="canShowRec"
        class="list-switch-item"
        :class="{ active: activeList === 'rec' }"
        @click="switchList('rec')"
      >
        推荐号码
      </div>
    </div>

    <!-- 投注号码列表：展示逻辑抽到 num/list/BetNumListView.vue -->
    <BetNumListView v-if="activeList === 'bet'" />
    <!-- 开奖号码列表：展示逻辑抽到 num/list/DrawNumListView.vue -->
    <DrawNumListView v-else-if="activeList === 'draw'" />
    <!-- 推荐号码列表：展示逻辑抽到 num/list/RecommendBetNumListView.vue -->
    <RecommendBetNumListView v-else />
  </div>
</template>

<script>
import BetNumListView from './num/list/BetNumListView.vue'
import DrawNumListView from './num/list/DrawNumListView.vue'
import RecommendBetNumListView from './num/list/RecommendBetNumListView.vue'
// 推荐号码可见性判断（仅 manager/vip 可见），与 LotteryMange 页"模型推荐"共用同一份逻辑
import { canShowModelRec } from '@/utils/role'

export default {
  name: 'NumManage',
  components: {
    BetNumListView,
    DrawNumListView,
    RecommendBetNumListView
  },
  data() {
    return {
      // 当前展示的列表：bet=投注号码（默认） / draw=开奖号码 / rec=推荐号码
      activeList: 'bet'
    }
  },
  computed: {
    // 推荐号码 tab 仅 manager（管理员）和 vip（VIP 用户）可见
    canShowRec() {
      return canShowModelRec()
    }
  },
  methods: {
    // 切换列表
    switchList(value) {
      if (this.activeList === value) return
      this.activeList = value
    },
    // 返回主页
    goBack() {
      this.$router.push('/home')
    }
  }
}
</script>

<style scoped>
/* 页面整体：与主页一致的手机门户风格 */
.page {
  width: 100%;
  max-width: 480px;
  min-height: 100%;
  margin: 0 auto;
  background: #f5f6fa;
}

/* ===== 顶部导航栏 ===== */
.nav-bar {
  position: relative;
  height: 48px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-back {
  position: absolute;
  left: 10px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.nav-back svg {
  width: 22px;
  height: 22px;
  fill: none;
  stroke: #fff;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.nav-title {
  color: #fff;
  font-size: 16px;
}

/* ===== 列表切换：左右两个按钮，默认选中投注号码 ===== */
.list-switch {
  display: flex;
  gap: 10px;
  padding: 10px 12px;
  background: #fff;
  border-bottom: 1px solid #ebeef5;
}

.list-switch-item {
  flex: 1;
  text-align: center;
  padding: 8px 0;
  border-radius: 8px;
  font-size: 14px;
  color: #606266;
  background: #f5f6fa;
  cursor: pointer;
}

/* 选中态：主题色渐变底 + 白字 */
.list-switch-item.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  font-weight: bold;
}
</style>
